import { uiCopy } from '@/shared/copy';
const DONE_PROGRESS = 0.99;
/** Next BM action on the BT_NOTIFICATIONS track. Notice comes from the agent after BT. */
export function btNotificationsNextStepTitle(stageCode) {
    if (stageCode === 'CONDUCT')
        return uiCopy.nextStepBtConduct;
    if (stageCode === 'GET_NOTICE')
        return uiCopy.nextStepBtAwaitNotice;
    return uiCopy.nextStepBtInvite;
}
function isBtWaitingStage(stageCode) {
    return stageCode === 'GET_NOTICE';
}
/**
 * Earliest incomplete funnel track becomes the next sales action for the BM.
 */
export function buildAgentNextStep(input) {
    const byId = new Map(input.tracks.map((track) => [track.id, track]));
    const btNotice = byId.get('BT_NOTIFICATIONS');
    if (!btNotice || (btNotice.progress ?? 0) < DONE_PROGRESS) {
        return {
            id: 'BT_NOTIFICATIONS',
            title: btNotificationsNextStepTitle(btNotice?.stageCode),
            href: btNotice?.boardHref ?? '/engagements?view=bt',
            hrefLabel: 'Доска БТ-Уведомление',
            waiting: isBtWaitingStage(btNotice?.stageCode),
        };
    }
    const projects = byId.get('PROJECT_ATTENDANCE');
    if (!projects || (projects.progress ?? 0) < DONE_PROGRESS) {
        return {
            id: 'PROJECT_ATTENDANCE',
            title: uiCopy.nextStepProjectAttendance,
            href: projects?.boardHref ?? '/engagements/projects',
            hrefLabel: 'Матрица проектов',
            waiting: false,
        };
    }
    const meeting = byId.get('MEETING_NOTICE');
    if (!meeting || meeting.pending || (meeting.progress ?? 0) < DONE_PROGRESS) {
        return {
            id: 'MEETING_NOTICE',
            title: uiCopy.nextStepMeeting,
            href: '/tasks',
            hrefLabel: 'Задачи',
            waiting: false,
        };
    }
    const agency = byId.get('AGENCY_CONTRACT');
    if (!agency || (agency.progress ?? 0) < DONE_PROGRESS) {
        return {
            id: 'AGENCY_CONTRACT',
            title: uiCopy.nextStepAgencyContract,
            href: agency?.boardHref ?? '/engagements?view=contract',
            hrefLabel: 'Доска Договор с АН',
            waiting: false,
        };
    }
    const completion = input.questionnaireCompletion ?? 0;
    if (completion < 80) {
        return {
            id: 'QUESTIONNAIRE',
            title: uiCopy.nextStepQuestionnaire,
            href: `/agents/${input.agentId}/questionnaire`,
            hrefLabel: uiCopy.fillQuestionnaire,
            waiting: false,
        };
    }
    return {
        id: 'DONE',
        title: uiCopy.nextStepDone,
        href: '/feedback',
        hrefLabel: uiCopy.salesSignalsFeedbackLink,
        waiting: false,
    };
}
export function digitsPhone(phone) {
    return phone.replace(/\D/g, '').replace(/^8/, '7');
}
/** Display phone as +7 XXX XXX-XX-XX when digits allow; otherwise raw input. */
export function formatPhoneDisplay(phone) {
    const digits = digitsPhone(phone);
    if (digits.length === 11 && digits.startsWith('7')) {
        return `+7 ${digits.slice(1, 4)} ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    }
    if (digits.length === 10) {
        return `+7 ${digits.slice(0, 3)} ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`;
    }
    return phone.trim();
}
export function telegramPhoneHref(phone) {
    const digits = digitsPhone(phone);
    const withCountry = digits.startsWith('7') ? digits : `7${digits}`;
    return `tg://resolve?phone=${withCountry}`;
}
